import { forwardRef } from 'react';
import TeethDiagramFdi from './teeth_fdi';
import TeethDiagramStandard from './teeth';
import TeethDiagramPrimary from './teeth_primary';

const TeethDiagram = forwardRef((props, ref) => {
    // The paediatric chart is a single component for both numbering systems: its
    // labels are <text> nodes driven by isFdi, not baked-in digit outlines.
    if (props.dentition === "primary")
        return (<TeethDiagramPrimary {...props} ref={ref} />)

    return (props.isFdi == true ? (<TeethDiagramFdi {...props} ref={ref} />) : (<TeethDiagramStandard {...props} ref={ref} />))
})

export default TeethDiagram;
